import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorState, Page, Skeleton } from '@/core/ui';
import { FlowBuilder, flowQuery, useFlow } from '@/modules/flows/public';
import { RequirePermission } from '@/modules/identity/public';

/** O builder de um fluxo. `aba` escolhe entre o canvas e os resultados — dá para mandar o link. */
export const Route = createFileRoute('/_admin/centuria/fluxos/$flowId')({
  validateSearch: z.object({
    aba: z.enum(['fluxo', 'resultados']).optional().catch(undefined),
  }),
  loader: ({ context, params }) => context.queryClient.prefetchQuery(flowQuery(params.flowId)),
  component: function FlowRoute() {
    const { flowId } = Route.useParams();
    const { aba } = Route.useSearch();
    const navigate = Route.useNavigate();
    const flow = useFlow(flowId);
    return (
      <RequirePermission anyOf={['centuria.fluxos']}>
        {flow.isPending ? (
          <Page>
            <Skeleton className="h-[70vh] rounded-3xl" />
          </Page>
        ) : flow.isError ? (
          <Page>
            <ErrorState error={flow.error} onRetry={() => void flow.refetch()} />
          </Page>
        ) : (
          <FlowBuilder
            // Remonta ao trocar de fluxo: o rascunho nasce dos dados dele.
            key={flow.data.id}
            flow={flow.data}
            tab={aba ?? 'fluxo'}
            onTab={(tab) =>
              void navigate({ search: { aba: tab === 'fluxo' ? undefined : tab }, replace: true })
            }
            onBack={() => navigate({ to: '/centuria/fluxos' })}
            onDeleted={() => navigate({ to: '/centuria/fluxos' })}
          />
        )}
      </RequirePermission>
    );
  },
});
